define(['../appContext',
    '../services/services',
    '../utils/tools'],
function (app, services, tools) {
    "use strict";

    var v = {};

    v.allViews = new tools.dictionary();
    v.allOriginalViews = new tools.dictionary();                //Here, we store views that are original when overwritten by pending changes (for the purpose of reverting) ... EK
    // #region Helpers

    v.createReqFromMVC = function (mvc) {
        let req = v.createReqFromDefinition(mvc.drivingView.Definition);

        if (mvc.pageRecordSize != null
            && mvc.pageRecordSize > 0
            && !Number.isNaN(Number(mvc.pageRecordSize))
            && !Number.isNaN(Number(mvc.pageCurrent))) {
            // validated good values for setting offset and limit.
            req.offset = mvc.pageRecordSize * (mvc.pageCurrent - 1);
            req.limit = mvc.pageRecordSize;
        }

        return req;
    };

    v.createReqFromDefinition = function (viewDefinition) {
        var lvr = {
            clientUTCoffset: 0 - (new Date().getTimezoneOffset() / 60),
            IsDetailView: viewDefinition.IsDetailView,
            Name: viewDefinition.Name,
            PrimaryRTID: viewDefinition.RecordTypeIDs[0],
            Cols: [],
            IncludeDeletedRecords: (viewDefinition.IncludeDeletedRecords == null ? false : viewDefinition.IncludeDeletedRecords)
        };

        if(viewDefinition.limit) {
            lvr.limit = viewDefinition.limit;
        }

        for (var i = 0, ilength = viewDefinition.ColumnProperties.length; i < ilength; i++) {
            let colReq = v.handleColumnReq(viewDefinition.ColumnProperties[i]);
            if (colReq != null) {
                lvr.Cols.push(colReq);
            }
        }

        return lvr;
    };

    v.handleColumnReq = function (colProp) {
        const propDataType = app.dv.types.PropertyDataType;

        // protect against SQL injection attacks...
        var replacedFilterVal = colProp.FilterValue;

        // this will replace the "{singlequote}" special code with single quote character(s).
        replacedFilterVal = app.dv.cache.session.applyVariablesColumnFilter(replacedFilterVal, colProp.Op);

        var propertyDef = app.dv.cache.properties.allProperties.getVal(colProp.PropertyID);

        // if we don't have a property or the property is "NEW" (a placeholder?) then don't attempt to pull down this column.
        if (propertyDef == null || propertyDef.PropertyID < 0) {
            return null;
        }
        //Check to see if the value needs a conversion
        switch (propertyDef.Definition.DataType) {
            case propDataType.StaticDateTime:
            case propDataType.DateTime:
                if (colProp.Op === 'In' || colProp.Op === 'Not In') {
                    // The in/not in operators needs to have the date accounted for all dates included in the filter value...EK
                    let filterVals = replacedFilterVal.split('|');
                    //Convert the dates to UTC, and join back to pipe delimited string...EK
                    replacedFilterVal = filterVals
                        .select(f => v.getSQLDateString(f, colProp.Op, propertyDef.Definition.Name))
                        .join('|');
                }
                else if (colProp.Op === 'Between') {
                    // The between operator needs to have the date accounted for both dates included in the filter value...EK
                    let filterVals = replacedFilterVal.split('|');
                    if (filterVals.length === 2) {
                        //Convert the dates to UTC, and join back to pipe delimited string...EK
                        replacedFilterVal = filterVals
                            .select(f => v.getSQLDateString(f, colProp.Op, propertyDef.Definition.Name))
                            .join('|');
                    }
                    else {
                        console.log(`Two arguments required for 'Between' operator.  Check filter for ${propertyDef.Definition.Name}`);
                    }
                }
                else {
                    //Convert date to format needed for Coactive backend
                    replacedFilterVal = v.getSQLDateString(replacedFilterVal, colProp.Op, propertyDef.Definition.Name);
                }
                break;
            default:
                //leave as is for now.
                break;
        }

        //Return the column request
        return {
            AutoDownloadBinary: colProp.AutoDownloadBinary,
            DataType: propertyDef.Definition.DataType,
            Op: colProp.Op,
            FilterValue: replacedFilterVal,
            PropertyID: colProp.PropertyID,
            RecordTypeID: colProp.RecordTypeID,
            Sort: colProp.Sort
        };
    };

    let allBackslashes = /\\/g, allSingleQuotes = /'/g;
    v.getSQLDateString = function (dateString, operator, propertyName) {
        propertyName = (propertyName == null ? '' : propertyName);

        if (dateString != null && dateString != '') {
            //Make sure the user is trying to compare a date.
            if (operator === '<=' || operator === '>=' || operator === '=' || operator === '!=' ||operator ==='>' || operator ==='<' || operator === 'Between' || operator === 'In' || operator === 'Not In') {
                let tempDateString,
                    tempDate,
                    isISO = false;
                if (tools.isDate(dateString)) {
                    // The filter value is already date object.
                    tempDate = dateString;
                }
                else {
                    if (typeof dateString === 'string' && dateString.length >= 4) {
                        //Declare tempDateString variable to use when evaluating date
                        tempDateString = dateString.replace(allBackslashes, '/').replace(allSingleQuotes, "");
                    }
                    isISO = app.dv.tools.isDateStringISO(tempDateString);
                    tempDate = new Date(tempDateString);
                }

                if (!tempDate || tempDate === "Invalid Date") {
                    //This is not a valid date
                    console.log('Invalid date filter for :' + propertyName);
                    return '';
                }

                if (isISO) {
                    // This was parsed as an international date, we need to correct the time offset from the new date
                    let tzOffset = tempDate.getTimezoneOffset();
                    if (tzOffset !== 0) {
                        tempDate.setMilliseconds(tempDate.getMilliseconds() + (tzOffset * 60000));
                    }
                }

                // Convert into MYSQL datetime format (YYYY-MM-DD HH:MM:SS)
                dateString = tempDate.getFullYear() + '-' +
                    ('00' + (tempDate.getMonth()+1)).slice(-2) + '-' +
                    ('00' + tempDate.getDate()).slice(-2) + ' ' +
                    ('00' + tempDate.getHours()).slice(-2) + ':' +
                    ('00' + tempDate.getMinutes()).slice(-2) + ':' +
                    ('00' + tempDate.getSeconds()).slice(-2) + '.' +
                    tempDate.getMilliseconds();
            }
        }

        //Return the date in a string
        return dateString;
    };

    // #endregion

    // #region Server Calls

    v.getLazyView = function (defID, callback) {
        let pendingRequests = 0;

        //First, we check the cache to see if we have this view in memory already, if so, we use it from the cache...EK
        let cachedView = v.allViews.getVal(defID);
        if (cachedView != null) {
            //If the view is a layout view, get the primary view and return it (bypass the layout view all together) ... EK
            if (cachedView.Definition.Type === app.dv.types.ViewType.LayoutView) {
                if (cachedView.Definition.PrimaryViewID == null || cachedView.Definition.PrimaryViewID === 0) {
                    //prevent views that are a Layoutview type and PrimaryViewID 0 WR/MD
                    callback(null);
                } else {
                    v.getLazyView(cachedView.Definition.PrimaryViewID, callback);
                }
            }
            else {
                callback(cachedView);
            }
        }
        else {
            //If not, we request it from the service (the response will not only have the view but also the supporting data structure for this view...EK
            //  (structure may not come down if the service already understands that we already have it) .. EK
            pendingRequests++;
            app.dv.services.call(app.dv.services.endpoints.getLazyView, defID, (result, error) => {
                lazyGetHandle(result, error, callback);
            });
        }

        function lazyGetHandle (result, error, callback) {
            pendingRequests--;
            if (error != null) {
                callback(null, error);
                return;
            }

            let cache = app.dv.cache;
            //The result should have the view definition, and possible the supporting data structure.

            // merge raw category JSON objects into cache as Record Type entities
            cache.recordTypes.mergeCache(result.RecordTypes);

            // merge raw category JSON objects into cache as Category entities (this will handle record type linking)
            cache.categories.mergeCache(result.Categories);

            // merge raw property JSON objects into cache as Property entities (this will handle category linking)
            cache.properties.mergeCache(result.Properties);

            result.View.Definition = JSON.parse(result.View.Definition);

            // before we add to the cache and move forward, check and see if we have a the record type for this view..
            if (!cache.recordTypes.allRecordTypes.getVal(result.View.Definition.RecordTypeIDs[0])) {
                /**
                 * We did not receive the record type (and categories, properties, etc.) for this view with this request.
                 * That means that it must be on another request that is processing near the same time for the same record type...
                 * So - we need to set a timer and allow the other request to respond with the entity information and then try again.
                 */

                // reset our pending request counter.
                pendingRequests++;

                // reset the Definition as a string for the reprocess...
                result.View.Definition = JSON.stringify(result.View.Definition);

                // wait 5ms and try to process the result again.
                setTimeout((r, e, c) => {
                    lazyGetHandle(r, e, c);
                }, 5, result, error, callback);

                // prevent attempting to process this response anymore - we will do it in the timeout.
                return;
            }
            cache.views.allViews.add(result.View.ViewID, result.View, result.View.UID);

            //We only want to return the first one that was originally requested (since this is a recursive call) ... EK
            if (cachedView == null) {
                cachedView = result.View;
            }

            //Check to see if the view that we got back has any drop down or agregate views, these must be loaded seperatley before we call back...EK
            //  NOTE: This list is limited to only those that manually load an MVC during the loading process...EK
            let supportingViews = [];

            if (result.View.Definition.ColumnProperties != null) {
                supportingViews = result.View.Definition.ColumnProperties.select(function (cp) { return cp.DropDownViewID; }).distinct(false);
                supportingViews = supportingViews.concat(result.View.Definition.ColumnProperties.select(function (cp) {
                    let forProp = cache.properties.allProperties.getVal(cp.PropertyID);
                    if (forProp != null) {
                        return forProp.Definition.RefViewID;
                    }
                    else
                        return null;
                }).distinct(false));
            }

            if (supportingViews.length > 0) {
                supportingViews.forEach(function (suppViewID) {
                    pendingRequests++;
                    app.dv.services.call(app.dv.services.endpoints.getLazyView, suppViewID, (r, e) => {
                        lazyGetHandle(r, e, callback);
                    });
                });
            }
            else {
                if (pendingRequests === 0) {
                    callback(cachedView);
                }
            }
        }
    };


    // Will call back with an integer value of the number of records for the passed in view / linked recordID
    v.getViewCount = function (view, linkedRecordID, callback) {

        var reqData = {
            "Session": app.dv.cache.session.sessionGUID,
            "viewReq": v.createReqFromDefinition(view.Definition),
            "linkedRecordID": linkedRecordID
        };
        services.call(services.endpoints.getViewCount, reqData, function (results) {
            if (results) callback(results.GetViewCountResult);
            else callback(); // No records -- TODO: error trap
        });
    };


    v.getViewByID = function (ID, callback) {
        var reqData = {
            Session: app.dv.cache.session.sessionGUID,
            ViewID: ID
        };

        services.call(services.endpoints.getViewByID, reqData, function (results) {
            callback(results);
        });
    };

    // #endregion

    v.applyClientProperties = function (entity) {
        if (entity == null) { return; }
        entity.clientProperties = new app.dv.entities.ClientProperties(app.dv.types.EntityTypes.View);
    };

    return v;
});
